


















import { Component, Vue, Prop } from 'vue-property-decorator';
import * as OM from '@/Model';
import * as VM from '@/viewModel';
import * as AgGrid from 'ag-grid-vue';
import DateFilter from '@/components/tableComponents/dateFilter.vue'
import OrderTypeFilter from '@/components/tableComponents/orderTypeFilter.vue'
import RemoveItemCell from '@/components/tableComponents/removeItemCell.vue'

@Component({
    components: {
        AgGridVue: AgGrid.AgGridVue,
    }
})
export default class MovimentiTable extends Vue {
    @Prop({
        type: Array
    }) rowData: OM.Ordine[];

    columnDefs: any[] = [
        { headerName: 'CreatedOn', field: 'createdOn', cellRendererFramework: DateFilter, width: 120 },
        { headerName: 'Data ordine', field: 'dataOrdine', cellRendererFramework: DateFilter, width: 120 },
        { headerName: 'Tipo movimento', field: 'tipoOrdine', cellRendererFramework: OrderTypeFilter, width: 100 },
        { headerName: 'Data movimento', field: 'dataMovimento', cellRendererFramework: DateFilter, width: 120 },
        { headerName: 'Nome', field: 'nomeAsset' },
        { headerName: 'Id Excel', field: 'idExcelStrumento' },
        { headerName: 'Quantita', field: 'quantita' },
        { headerName: 'Prezzo', field: 'prezzo' },
        { headerName: 'Controvalore', field: 'controvalore' },
        { headerName: 'Controvalore Valuta', field: 'controvaloreValuta' },
        { headerName: 'Valuta', field: 'valuta', width: 120 },
        { headerName: 'Elimina', width: 120, cellRendererFramework: RemoveItemCell },
    ];
        
    gridOptions: any = {
        context: {
            componentParent: this
        }
    };
    
    fullTextFilter: string = "";
    onFilterTextBoxChanged(){
        this.gridOptions.api.setQuickFilter(this.fullTextFilter);
    }
    mounted(){
        this.gridOptions.api.sizeColumnsToFit();
        window.addEventListener('resize', this.onResize);
    }
    onResize(){
        setTimeout(() => {
            this.gridOptions.api.sizeColumnsToFit();
        });
    }
    destroyed(){
        window.removeEventListener('resize', this.onResize);
    }

    removeItem(data){
        this.$emit('removeitem', data);
    }

}
